<template>
  <div class="chart-legend">
    <div
      class="chart-legend__color"
      :style="{ backgroundColor: legend.color }" />
    <div class="chart-legend__label">
      {{ legend.label }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    legend: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.chart-legend {
  display: flex;
  justify-content: center;
  align-items: center;

  &__color {
    width: 20px;
    height: 4px;
  }

  &__label {
    padding-left: 4px;
    font-size: $fs-s;
  }
}

</style>